module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-INDIEGOGO.31a5ccf1.png";